import { useState, useEffect } from 'react';
import { templateService } from '../services/templateService';
import type { ContractTemplate, TemplateType } from '@shared/types';

interface TemplateFilters {
  type?: TemplateType;
}

export function useTemplates(filters?: TemplateFilters) {
  const [templates, setTemplates] = useState<ContractTemplate[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  const loadTemplates = async () => {
    try {
      setLoading(true);
      setError(null);
      const data = await templateService.getTemplates(filters);
      console.log('Loaded templates:', data);
      setTemplates(data);
    } catch (err) {
      console.error('Error loading templates:', err);
      setError(err instanceof Error ? err.message : 'Failed to load templates');
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    loadTemplates();
  }, [filters?.type]);

  return {
    templates,
    loading,
    error,
    reload: loadTemplates,
  };
}

